import { render } from "./FormCollapseAlertComponent.vue?vue&type=template&id=7381633f&scoped=true"
import script from "./FormCollapseAlertComponent.vue?vue&type=script&lang=js"
export * from "./FormCollapseAlertComponent.vue?vue&type=script&lang=js"

import "./FormCollapseAlertComponent.vue?vue&type=style&index=0&id=7381633f&lang=scss&scoped=true"
import "./FormCollapseAlertComponent.vue?vue&type=style&index=1&id=7381633f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7381633f"]])

export default __exports__